import { MultiSelect } from "@/components/ui/FormFields/MultiselectFormField/MultiselectFormField";
import { retrieveClaimTypesQueryOptions } from "@/lib/data/react-query/matters/claim-type";
import { useQuery } from "@tanstack/react-query";

export function ClaimTypeFilter({
  value,
  onChange,
}: {
  value: string[];
  onChange: (value: string[]) => void;
}) {
  const { data, isLoading, isError } = useQuery(
    retrieveClaimTypesQueryOptions(),
  );
  return (
    <div>
      <MultiSelect
        aria-label="Claim types"
        placeholder="Claim types"
        options={(data?.data ?? []).map((claimType) => ({
          value: claimType.id,
          label: claimType.label,
        }))}
        selectedValues={value}
        setSelectedValues={() => {}}
        onValueChange={onChange}
        isLoading={isLoading}
        disabled={isError}
        ignoreAllSelected
      />
      {isError && (
        <p role="alert" className="text-destructive text-sm">
          Claim types could not be loaded.
        </p>
      )}
    </div>
  );
}
